import { useQuery } from '@tanstack/react-query';
import { lowStockApi, LowStockItem } from '@/services/api/lowStock';

// Товары, у которых остаток не больше минимума из карточки товара
export const useLowStock = (warehouseId?: number) => {
  return useQuery({
    queryKey: ['lowStock', warehouseId],
    queryFn: () => lowStockApi.getLowStockItems(warehouseId),
    staleTime: 60000, // 1 минута
    refetchInterval: 300000, // Обновляем каждые 5 минут
  });
};

// Экспорт типов
export type { LowStockItem };
